import OddPaper from './OddPaper.view';

export default OddPaper;
